"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var __1 = require("..");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
exports.default = react_1.forwardRef(function SimpleAccordion(_a, ref) {
    var data = _a.data, _b = _a.singleMode, singleMode = _b === void 0 ? false : _b;
    var _c = react_1.useState({}), openKeys = _c[0], setOpenKeys = _c[1];
    var handleChange = function (index) { return function (_event, isExpanded) {
        var _a, _b;
        if (singleMode) {
            setOpenKeys((_a = {}, _a[index] = isExpanded, _a));
        }
        else {
            setOpenKeys(__assign(__assign({}, openKeys), (_b = {}, _b[index] = isExpanded, _b)));
        }
    }; };
    var classes = useStyles();
    return (jsx_runtime_1.jsx("div", __assign({ ref: ref }, { children: data.map(function (_a, index) {
            var _b;
            var summary = _a.summary, details = _a.details, subtitle = _a.subtitle;
            return (jsx_runtime_1.jsxs(__1.Accordion, __assign({ expanded: openKeys[summary + index] || false, onChange: handleChange(summary + index) }, { children: [jsx_runtime_1.jsxs(__1.AccordionSummary, __assign({ expandIcon: jsx_runtime_1.jsx(__1.Icon.ExpandMore, {}, void 0) }, { children: [jsx_runtime_1.jsx(__1.H6, __assign({ className: classnames_1.default((_b = {}, _b[classes.heading] = Boolean(subtitle), _b)) }, { children: summary }), void 0),
                            Boolean(subtitle) && jsx_runtime_1.jsx(__1.Body2, __assign({ className: classes.subheading }, { children: subtitle }), void 0)] }), void 0),
                    jsx_runtime_1.jsx(__1.AccordionDetails, { children: typeof details === 'string' ? jsx_runtime_1.jsx(__1.Body2, { children: details }, void 0) : details }, void 0)] }), summary + index));
        }) }), void 0));
});
var useStyles = core_1.makeStyles({
    heading: {
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    subheading: {
        alignSelf: 'center',
    },
});
//# sourceMappingURL=SimpleAccordion.js.map